interface LogoProps {
  className?: string
  size?: number
}

const Logo = ({ className = '', size = 32 }: LogoProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      {/* Rounded square background */}
      <rect
        width="32"
        height="32"
        rx="8"
        className="fill-zinc-950 dark:fill-zinc-50"
      />
      {/* Stylized "B" / bracket monogram */}
      <path
        d="M10 9.5C10 8.67157 10.6716 8 11.5 8H17C19.4853 8 21.5 10.0147 21.5 12.5V12.5C21.5 14.0186 20.7282 15.3681 19.5355 16.1421C20.7282 16.9162 21.5 18.2657 21.5 19.7843V19.7843C21.5 22.2696 19.4853 24.2843 17 24.2843H11.5C10.6716 24.2843 10 23.6128 10 22.7843V9.5Z"
        className="fill-white dark:fill-zinc-950"
      />
      <rect
        x="13"
        y="12"
        width="4"
        height="2"
        rx="1"
        className="fill-zinc-950 dark:fill-zinc-50"
      />
      <rect
        x="13"
        y="18"
        width="4"
        height="2"
        rx="1"
        className="fill-zinc-950 dark:fill-zinc-50"
      />
    </svg>
  )
}

export default Logo
